<template>
  <nav class="fixed top-0 left-0 right-0 z-50 flex items-center h-20 px-6 sm:px-12 transition-all duration-300">
    <router-link to="/" class="flex items-center shrink-0">
      <img src="@/assets/tracktalent_logo.svg" alt="TrackTalent Logo" class="h-10 object-contain invert" />
    </router-link>

    <router-link to="/explore/jobs" class="ml-6">
      <Button variant="ghost" class="text-white bg-black/20 hover:text-[#1a66e6] font-medium text-sm sm:text-base px-4 py-2 hover:bg-gray-50/50 rounded-full transition-colors">
        Explore Jobs
      </Button>
    </router-link>

    <div class="ml-auto flex items-center gap-4">
      <router-link to="/login">
        <Button variant="ghost" class="text-white bg-black/20 hover:text-[#1a66e6] font-medium text-sm sm:text-base px-4 py-2 hover:bg-gray-50/50 rounded-full transition-colors">
          Log In
        </Button>
      </router-link>
      <router-link to="/register">
        <Button class="text-white hover:bg-black rounded-full px-6 sm:px-8 py-2 text-sm sm:text-base font-medium shadow-md transition-all hover:shadow-lg hover:-translate-y-0.5 active:scale-95 duration-200">
          Get Started
        </Button>
      </router-link>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button'
</script>

<style scoped>
nav {
  padding-left: max(1.5rem, env(safe-area-inset-left));
  padding-right: max(1.5rem, env(safe-area-inset-right));
}
</style>
